
   
    
    <div class="uk-child-width-1-1@s" uk-grid>
        <div>
            <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
                   style="background-image: url(../../assets/crossbanner.png);">
                <div class="uk-section uk-light">
                    <div class="uk-container-small uk-width-2xlarge" style="padding-top: 40px;">
                        <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Cross platform Application Development </h1></div>
                        <div>
                            <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">At WebSoulLabs we
                                 have the best and efficient code experts who are specialized in tools like phoneGap, Xamarin etc
                                  to make your applications compatible .
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="uk-section uk-padding" style="padding-bottom: 0px;">
        <div class="uk-container">
            
                
            <h2 class="uk-text-center" style="font-weight: 600;">  Get to know about Cross Platform App Development

            </h2>
            <br>
            <div class="uk-column-1-2@s">
                
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Cross-platform application
                     development frameworks allow developers to create mobile applications that are platform 
                     independent, in this case, iOS and Android. It provides them with the ability to write 
                     the code once, and then run it anywhere for other platforms too, thereby enabling to
                      release a application/software faster, safer, efficient and with better quality.
                       Cross-platform frameworks seek to generate an application that reaches out to as 
                       many followers of your brand as possible by covering a wide number of end devices 
                       during the programming and creation process. To make your app stand out  in such a
                        complex scenario, you need to be very particular about the approach being followed
                        . Our development teams don’t have to invest time and 
                         money in learning multiple technologies.</p>
                <div>
                    <img data-src="assets/cross1.jpg" width="600" height="600" alt="swift pics" uk-img>
                </div>
            </div>
        
            <br>
            <div class="uk-column-1-2@s">
                <div>
                    <img data-src="assets/cross2.jpg" width="600" height="600" alt="swift pics" uk-img>
                </div>
                <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Cross-platform application
                     development has become very popular at the present time. Customers find an app clumsy 
                     and inefficient if they need to use different methodologies for accessing the same app 
                     across different mobile phones. As we know Cross-platform  is the
                      way of creating mobile applications in such a way that they can be run on different 
                      platforms. With  cross-platform  approach, the development teams don’t have to write 
                      separate code for different platforms. Instead, the program developed for one app gets
                       supported many times. Developers like such a development because in this, programming
                        is done only once and the application is supported by Android, iOS or Windows. 
                </p>
               
            </div>
        </div>  <!--container div-->
    </div>
       <br>
        <div class="uk-section uk-section-default" style="padding-top: 0px;">
            <div class="uk-container">
                <h2 class="uk-text-center" style="font-weight: 600;"><span>Mark our pros</span></h2>
                <br>
                <div class="uk-column-1-2@s">
                    
                    <div>
                        <ul class="uk-list uk-list-disc uk-text-medium" style="font-size: 18px;">
                            <li><b>Reusable Code Components :</b>It is with code base used in bits for future
                                 projects. Allows developers to reuse or replicate a substantial part of the 
                                 code to be used for different platforms.</li>
                            <li><b> Simple Marketing :</b>Foundation to promote development related to CakePHP.</li>
                            <li><b> Cost-Efficient :</b>The query builder providers a set of classes and methods for programmatically.</li>
                            <li><b> Uniform Appeal :</b>The ORM makes extensive use of the query builder. </li>
                            <li><b> Low Development Costs :</b>costs are automatically reduced ORM makes extensive use of the query builder. </li>
                            <li><b> Fast & Reliable :</b>Makes it more efficient than multiple ones from scratch. </li>


                        </ul>
                    </div>
                    <div>
                        <img data-src="assets/cross3.jpg" width="600" height="600" alt="" uk-img>
                    </div>
                </div>
            </div>  
        </div>  

    
         
        <div class="uk-container uk-container-expand">
            <h1 class="uk-padding-small uk-text-center" style="color:snow; margin-bottom: 0px; padding-bottom: 35px; font-weight: 600;">Cross Platform App Development Service </h1>
            <div class="ws-services  uk-child-width-1-2@s uk-child-width-1-3@m uk-flex-center uk-padding uk-light uk-grid-match" style="padding-bottom: 0px; padding-top: 0px; margin-bottom: 15px; margin-top: 15px;" uk-grid>
                
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding" style="padding-top:10px;" >
                        
                        <img class="uk-align-center" style="margin-bottom: 10px;" src="assets/x.png" width="68" height="68" alt="border-circle">
                            
                        
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Xamarin</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;word-spacing:1px;letter-spacing: -1px;"> Xamarin is an open-source platform 
                            for building modern and efficient applications for iOS, Android, and Windows with .NET.</p>
                    </div>
                </div>
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        
                        <img class=" uk-align-center" style="margin-bottom: 20px;" src="assets/k.png" width="68" height="68" alt="border-circle">
                            
                        
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Kinvey</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;word-spacing:1px;letter-spacing: -1px;">Kinvey is meant to enable developers and established enterprises to deliver
                             their different mobile, website  applications.
                        </p>
                    </div>
                </div>
                <div>

                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        <img class=" uk-align-center"  style="margin-bottom: 10px;" src="assets/plus.png" width="55" height="55" alt="border-circle">
                            
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Mag+</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;word-spacing:1px;letter-spacing: -1px;">The mag+ Publishing
                             platform consists a set of tools and  a web-based app building and app management tool.
                        </p>
                    </div>
                </div>
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        <img class="uk-align-center" style="margin-bottom: 5px;" style="margin-bottom: 0px;" src="assets/pg.png" width="68" height="68" alt="border-circle">
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>PhoneGap</strong></h3>
                        <p class="uk-text-center uk-text-justify " style="color: snow; margin-top: 10px;word-spacing:1px;letter-spacing: -1px;">PhoneGap is a software development framework by Adobe System, which is used to create mobile applications.</p>
                    </div>
                </div>
                
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">

                        <img class="uk-align-center"  style="margin-bottom: 15px;" src="assets/app.png" width="60" height="60" alt="border-circle">
                        <h3 style="margin-bottom: 10px; margin-top: 0px;" ><strong>Appcelerator</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;word-spacing:1px;letter-spacing: -1px;">Appcelerator allows the creation of native, hybrid, or mobile web 
                            apps across platforms including iOS, Android, Windows Phone from a single JavaScript.
                        </p>
                    </div>
                </div>
                
                <div>
                    <div class="uk-placeholder uk-text-center uk-panel uk-padding"  style="padding-top:15px;">
                        <img class=" uk-align-center" style="margin-bottom: 5px;" src="assets/sap.png" width="60" height="60" alt="border-circle">
                        <h3 style="margin-bottom: 10px; margin-top: 0px;"><strong>Sap</strong></h3>
                        <p class="uk-text-center uk-text-justify" style="color: snow; margin-top: 10px;word-spacing:1px;letter-spacing: -1px;">SAP stands for Systems Application
                             and products. They develop software solutions for managing business applications and customer relationships.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        
        <h1 class="uk-text-center" style="margin-bottom: 0px;"><span>Related Services</span></h1>
        <BR><BR>
            
        <div class="uk-container">
            <div class="uk-grid-small  uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                       
                        <img class=" uk-align-center" src="assets/icons/ig1.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center" style="font-weight:600">IPhone App<br> Development</h4>
                
                    </div>
                </div>
               
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                        <img class="uk-border-pill uk-align-center" src="assets/icons/androigg13.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center" style="font-weight:600">Android App<br> Development</h4>
                    
                    
                    </div>
                </div>
              
        
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                        <img class=" uk-align-center" src="assets/icons/gapg1.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center" style="font-weight:600">PhoneGap App<br> Development</h4>
                    </div>
                </div>
        
                <div>
               
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                        <img class=" uk-align-center" src="assets/icons/xamaring10.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center" style="font-weight:600">Xamarin App<br> Development</h4>
        
                   
                    </div>
                </div>
        
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                        <img class=" uk-align-center" src="assets/icons/mobileg1.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center" style="font-weight:600">Mobile App<br> Development</h4>
        
                   
                    </div>
                </div>
        
               
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium"  style="padding-top: 30px;">
                        <img class=" uk-align-center" src="assets/icons/swiftg9.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center" style="font-weight:600">Swift App<br> Development</h4>
        
                    </div>
                </div>
               
            </div>
        

        </div>
        <h1 class="uk-text-center"><span>Technology Stack</span></h1>
    <br>
    <div class="uk-container">
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/swi.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Swift</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/and.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Android</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/java.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Java</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/apple.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Ios</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/kotlin.jpg" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Kotlin</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/Fabric.jpg" width="85" height="85"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Fabric</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/xamarin.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Xamarin</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/React.webp" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">React Js</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-large uk-grid-match" uk-grid>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/appt.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Appcelerator Titanium</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/flutter.png" width="80" height="80"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Flutter</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/back.png" width="130" height="130"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Backbone</h4>
                </div>
            </div>
            <div>
                <div class="uk-placeholder uk-text-center uk-panel uk-padding">
                    <img class="uk-border-circle uk-align-center" src="assets/ember.png" width="90" height="90"
                        alt="border-circle">
                    <h4  style="font-weight: 600;">Ember</h4>
                </div>
            </div>
        </div>
    </div>
    <br>



    <!--div after banner-->


    


